export const items = [
    {
        label: 'Dla użytkownika',
        items: [
            {
                label: 'Skąpiec radzi',
                href: 'https://www.skapiec.pl/radzi',
                title: 'Skąpiec radzi'
            },
            {
                label: 'Zasady sortowania',
                href: '/zasady-sortowania',
                title: 'Zasady sortowania',
                rel: 'nofollow'
            },
            {
                label: 'Najczęściej zadawane pytania',
                href: '/site/doc/4',
                title: 'Najczęściej zadawane pytania',
                rel: 'nofollow'
            },
            {
                label: 'Jak to działa?',
                href: '/site/doc/3',
                title: 'Jak to działa?',
                rel: 'nofollow'
            },
            {
                label: 'Twoje zgody',
                href: 'https://zgody.skapiec.pl/',
                title: 'Twoje zgody w serwisie skapiec.pl',
                rel: 'nofollow'
            },
            {
                label: 'Regulamin',
                href: '/regulamin-uzytkownika',
                title: 'Regulamin użytkownika',
                rel: 'nofollow'
            },
            {
                label: 'Newsletter',
                href: '/newsletter',
                title: 'Zapisz się na newsletter już dziś!',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Dla sklepów',
        items: [
            {
                label: 'Dołącz do Skąpiec.pl',
                href: '/dla-sklepow',
                title: 'Chcesz zwiększyć sprzedaż?',
                rel: 'nofollow'

            },
            {
                label: 'Raport Sklepów 2022',
                href: 'https://ranking.opineo.pl/?utm_source=stopka&utm_medium=skapiec.pl',
                title: 'Ranking Sklepów Internetowych 2022 - Najlepsze sklepy w Opineo.pl',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Dla partnerów',
        items: [
            {
                label: 'Program Partnerski',
                href: '/site/doc/402',
                title: 'Informacje ogólne',
                rel: 'nofollow'
            },
            {
                label: 'FAQ - Program Partnerski',
                href: '/site/doc/402/11',
                title: 'Pytania i odpowiedzi',
                rel: 'nofollow'
            },
            {
                label: 'API Skąpiec',
                href: '/site/doc/400',
                title: 'API Skąpiec.pl',
                rel: 'nofollow'
            },
            {
                label: 'Regulamin',
                href: '/regulamin-programu-partnerskiego',
                title: 'REGULAMIN DLA PARTNERÓW PROGRAMU PARTNERSKIEGO MONETEASY22',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Skąpiec.pl',
        items: [
            {
                label: 'O nas',
                href: '/o-nas',
                title: 'O nas',
                rel: 'nofollow'
            },
            {
                label: 'Centrum prasowe',
                href: '/site/doc/200',
                title: 'Komunikaty prasowe',
                rel: 'nofollow'
            },
            {
                label: 'Gwiazda Jakości Obsługi',
                href: '/lp/gwiazda-jakosci-obslugi',
                title: 'Gwiazda Jakości Obsługi',
                rel: 'nofollow'
            },
            {
                label: 'Kariera',
                href: 'https://www.ringieraxelspringer.pl/kariera/oferty-pracy/',
                title: 'Pracuj w Ringier Axel Springer',
                rel: 'nofollow'
            },
            {
                label: 'Kontakt',
                href: '/kontakt',
                title: 'Kontakt',
                rel: 'nofollow'
            }
        ]
    }
] as {
    label: string;
    items: {
        label: string;
        href: string;
        title: string;
        target: '_blank';
        rel: string;
    }[];
}[];

export const media = [
    {
        label: 'Facebook',
        href: 'https://www.facebook.com/Skapiec',
        title: 'Facebook',
        rel: 'follow noopener',
        icon: 'facebook-filled'
    },
    {
        label: 'Instagram',
        href: 'https://www.instagram.com/skapiec_pl/',
        title: 'Instagram',
        rel: 'follow noopener',
        icon: 'instagram'
    },
    {
        label: 'Linkedin',
        href: 'https://pl.linkedin.com/company/skapiec-pl',
        title: 'Linkedin',
        rel: 'follow noopener',
        icon: 'linkedin'
    },
    {
        label: 'Tiktok',
        href: 'https://www.tiktok.com/@skapiec_pl',
        title: 'Tiktok',
        rel: 'follow noopener',
        icon: 'tiktok'
    }
] as {
    label: string;
    href: string;
    title: string;
    rel: string;
    icon: string;
}[];
